<template>
  <div>
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title class="breadcrumbs d-flex align-center">
        <v-icon class="text-primary">{{ icons.arrowLeft }}</v-icon>
        <router-link
          class="text-decoration--none"
          :to="{ name: 'trips.listing' }"
          >Trips</router-link
        >
      </v-toolbar-title>
    </v-app-bar>

    <div class="ma-4" v-if="form">
      <div class="display-2 font-weight-bold my-6 text-capitalize">
        Create Trip
      </div>

      <v-form ref="form" v-if="form" class="place-form">
        <v-row class="create-trip__content">
          <!-- Trip Form -->
          <v-col class="col-md-4 col-sm-12 col-xs-12 mt-6 pa-0">
            <h3 class="py-5 primary--text">Trip Information</h3>

            <label class="text-field-label">Name</label>
            <v-text-field
              flat
              solo
              required
              class="mt-2"
              v-model="form.name"
              :error-messages="form.$getError('name')"
              :loading="loading"
            ></v-text-field>

            <label class="text-field-label">Type</label>
            <v-select
              class="mt-2"
              v-model="form.types"
              :items="tripTypes"
              :loading="fetchingTripTypes"
              filled
              multiple
              item-text="name"
              item-value="id"
              :error-messages="form.$getError('types')"
            >
              <template v-slot:append-outer>
                <v-btn
                  color="normal"
                  @click="getTripTypes()"
                  :loading="fetchingTripTypes"
                  icon
                >
                  <v-icon>
                    {{ icons.refresh }}
                  </v-icon>
                </v-btn>
              </template>
            </v-select>

            <label class="text-field-label">Accommodation Type</label>
            <v-select
              class="mt-2"
              v-model="form.accommodation_types"
              :items="accommodationTypes"
              :loading="fetchingAccommodationTypes"
              filled
              multiple
              item-text="name"
              item-value="id"
              :error-messages="form.$getError('accommodation_types')"
            >
              <template v-slot:append-outer>
                <v-btn
                  color="normal"
                  @click="getAccommodationTypes()"
                  :loading="fetchingAccommodationTypes"
                  icon
                >
                  <v-icon>
                    {{ icons.refresh }}
                  </v-icon>
                </v-btn>
              </template>
            </v-select>

            <v-divider></v-divider>

            <h3 class="py-5 primary--text">Itinerary Information</h3>

            <label class="text-field-label">Origin</label>
            <v-text-field
              flat
              solo
              readonly
              class="mt-2"
              v-model="form.origin_address"
              :error-messages="form.$getError('destination')"
              :loading="loading"
              persistent-hint
              hint="Note: Origin will be base on the origin
              of the first day"
            ></v-text-field>

            <label class="text-field-label">Destination</label>
            <v-text-field
              flat
              solo
              readonly
              class="mt-2"
              v-model="form.destination_address"
              :error-messages="form.$getError('destination')"
              :loading="loading"
              persistent-hint
              hint="Note: Destination will be base on the destination
              of the last day"
            ></v-text-field>

            <ItineraryTemplate
              :itineraryTemplate="form.itinerary_activity_template_ids"
              :errorMessage="form.$getError('itinerary_activity_template_ids')"
              @add="addItineraryTemplate"
              @remove="removeItineraryTemplate($event)"
            ></ItineraryTemplate>

            <div class="mt-5 d-flex">
              <v-btn
                color="normal"
                height="40px"
                width="47%"
                :loading="form.$busy"
                :to="{ name: 'trips' }"
                >Back</v-btn
              >

              <v-spacer></v-spacer>

              <v-btn
                color="primary"
                height="40px"
                width="47%"
                :loading="form.$busy"
                @click="saveTripDetails"
                >Save</v-btn
              >
            </div>
          </v-col>

          <v-col class="col-md-5 offset-md-1 col-sm-12 col-xs-12 mt-6 pl-10">
            <h3 class="py-5 primary--text">Media Information</h3>
            <trip-media-form
              :tripMedia="tripMedia"
              :mediaLoading="mediaLoading"
              :error="form.$getError('photos')"
              @change="mediaChange"
              @delete="removeMedia"
            />

            <!-- <v-divider></v-divider> -->

            <!--            <PointOfInterest-->
            <!--              :pointOfInterest="form.point_of_interests"-->
            <!--              :pointOfInterestAddress="form.point_of_interests_address"-->
            <!--              @add="addPointOfInterest"-->
            <!--              @remove="removePointOfInterest($event)"-->
            <!--              @update="updatePointOfInterest($event)"-->
            <!--            ></PointOfInterest>-->
            <!--
            <h3 class="py-5 primary--text">Points of Interest</h3>
            <label class="text-field-label">Landmarks</label>
            <v-autocomplete
              class="mt-2"
              v-model="form.point_of_interests.place_ids"
              :items="landmarks"
              :loading="fetchingLandmarks"
              filled
              multiple
              item-text="name"
              item-value="id"
              :error-messages="form.$getError('place_ids')"
            >
              <template v-slot:append-outer>
                <v-btn
                  color="normal"
                  @click="getLandmarks()"
                  :loading="fetchingLandmarks"
                  icon
                >
                  <v-icon>
                    {{ icons.refresh }}
                  </v-icon>
                </v-btn>
              </template>
            </v-autocomplete>

            <label class="text-field-label">Shops</label>
            <v-autocomplete
              class="mt-2"
              v-model="form.point_of_interests.place_ids"
              :items="stores"
              :loading="fetchingStores"
              filled
              multiple
              item-text="name"
              item-value="id"
              :error-messages="form.$getError('place_ids')"
            >
              <template v-slot:append-outer>
                <v-btn
                  color="normal"
                  @click="getStores()"
                  :loading="fetchingStores"
                  icon
                >
                  <v-icon>
                    {{ icons.refresh }}
                  </v-icon>
                </v-btn>
              </template>
            </v-autocomplete>

            <label class="text-field-label">Restaurants</label>
            <v-autocomplete
              class="mt-2"
              v-model="form.point_of_interests.place_ids"
              :items="restaurants"
              :loading="fetchingRestaurants"
              filled
              multiple
              item-text="name"
              item-value="id"
              :error-messages="form.$getError('place_ids')"
            >
              <template v-slot:append-outer>
                <v-btn
                  color="normal"
                  @click="getRestaurants()"
                  :loading="fetchingRestaurants"
                  icon
                >
                  <v-icon>
                    {{ icons.refresh }}
                  </v-icon>
                </v-btn>
              </template>
            </v-autocomplete>
            -->
          </v-col>
        </v-row>
      </v-form>
      <!-- End of Trip Form -->
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */

import ControlsMixin from '@/utils/mixins/Controls'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'

import TripMediaForm from './components/TripMediaForm'
import ItineraryTemplate from './components/ItineraryTemplate'

import Form from '@/utils/form'
import { mapState, mapActions } from 'vuex'
import TripForm from '@/utils/mixins/TripForm'

export default {
  name: 'CreateTrip',

  mixins: [ControlsMixin, TripForm],

  components: {
    AppBarNavIcon,
    TripMediaForm,
    ItineraryTemplate
  },

  data() {
    return {
      form: {
        origin: {},
        origin_address: '',
        destination: {},
        destination_address: '',
        point_of_interests: {
          place_ids: []
        }
      },
      mediaLoading: false,
      tripMedia: []
    }
  },

  computed: {
    ...mapState({
      trip: state => state.trip.tripDetails,
      itineraryDetails: state => state.itinerary.itineraryDetails
    })
  },

  created() {
    this.clearTripDetails()
    this.getDropdownOptions()
    this.form = new Form(this.trip)
    this.loading = false
  },

  watch: {
    async 'form.itinerary_activity_template_ids'() {
      this.form.$busy = true

      if (!this.form.itinerary_activity_template_ids[0]) {
        this.form.$busy = false
        return false
      }

      try {
        const [firstRoute, lastRoute] = await Promise.all([
          this.getItineraryDetails(
            this.form.itinerary_activity_template_ids[0]
          ),
          this.getItineraryDetails(
            this.form.itinerary_activity_template_ids.slice(-1)[0]
          )
        ])

        const origin = firstRoute.data.stops[0]
        const destination = lastRoute.data.stops?.slice(-1)[0]

        this.form.origin_address = origin?.places_address ?? ''
        this.form.origin = origin?.google_places_id ?? ''

        this.form.destination_address = destination?.places_address ?? ''
        this.form.destination = destination?.google_places_id ?? ''

        this.form.$busy = false
      } catch (err) {
        this.form.$busy = false
        this.setAlert({
          message: err.response.data.message,
          color: 'error'
        })
      }
    }
  },

  methods: {
    ...mapActions({
      createTrip: 'trip/createTrip',
      clearTripDetails: 'trip/clearTripDetails',
      getItineraryDetails: 'itinerary/getItineraryDetails',
      setAlert: 'alert/setAlert'
    }),

    addItineraryTemplate() {
      this.form.itinerary_activity_template_ids.push('')
    },

    removeItineraryTemplate(index) {
      this.form.itinerary_activity_template_ids.splice(index, 1)
    },

    updateItineraryTemplate(template) {
      this.form.itinerary_activity_template_ids[template.id] = template.value
    },

    mediaChange(files) {
      files.forEach((file, index) => {
        file['url'] = URL.createObjectURL(file)
        file['id'] = this.tripMedia.length

        this.tripMedia.push(file)
      })
    },

    removeMedia(mediaId) {
      let media = this.tripMedia.find(x => x.id === mediaId)
      let index = this.tripMedia.indexOf(media)
      this.tripMedia.splice(index, 1)
    },

    addPointOfInterest() {
      this.form.point_of_interests_address.push('')
      this.form.point_of_interests.push('')
    },

    removePointOfInterest(index) {
      this.form.point_of_interests_address.splice(index, 1)
      this.form.point_of_interests.splice(index, 1)
    },

    updatePointOfInterest(poi) {
      this.form.point_of_interests[poi.id] = poi.value
    },

    async saveTripDetails() {
      this.form.$busy = true
      this.form.$clearErrors()
      this.form.photos = this.tripMedia

      let data = new FormData()
      data.append('name', this.form.$data().name)

      // Check if image is valid file
      if (this.form.photos !== null) {
        let photoInfo = Object.values(this.form.photos)
        let _this = this
        photoInfo.forEach(function(item, index) {
          if (_this.form.photos[index] instanceof File) {
            data.append('photos[' + index + ']', item)
          }
        })
      }

      // Check if trip type is null
      if (this.form.types !== null) {
        let tripTypes = Object.values(this.form.types)
        tripTypes.forEach(function(item, index) {
          data.append('types[' + index + ']', item)
        })
      }

      // Check if accommodation type is null
      if (this.form.accommodation_types !== null) {
        let accommodationTypes = Object.values(this.form.accommodation_types)
        accommodationTypes.forEach(function(item, index) {
          data.append('accommodation_types[' + index + ']', item)
        })
      }

      // Check if point of interests is null
      if (this.form.point_of_interests !== null) {
        let poiList = this.form.point_of_interests.place_ids
        poiList.forEach(function(item, index) {
          data.append('point_of_interests[' + index + ']', item)
        })
      }

      // Check if origin is provided
      if (this.form.origin !== null) {
        data.append('origin', this.form.origin)
      }

      // Check if destination is provided
      if (this.form.destination !== null) {
        data.append('destination', this.form.destination)
      }

      // Check if itinerary template is null
      if (this.form.itinerary_activity_template_ids !== null) {
        let itineraryList = Object.values(
          this.form.itinerary_activity_template_ids
        )
        itineraryList.forEach(function(item, index) {
          if (item !== '') {
            data.append('itinerary_activity_template_ids[' + index + ']', item)
          }
        })
      }

      this.createTrip(data)
        .then(() => {
          this.form.$busy = false
          this.setAlert({
            message: 'Trip details successfully saved!',
            color: 'success'
          })
          this.$router.replace({ name: 'trips.listing' })
        })
        .catch(err => {
          this.form.$busy = false
          if (err.response.status === 422) {
            this.form.$setErrors(err.response.data.errors)
          }
        })
    }
  }
}
</script>
